import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import StatusLabel from '@/shared/components/StatusLabel';
import { formatListValue } from '@/shared/components/FormattedListValue';
var Status;
(function (Status) {
    Status[Status["Initialized"] = 0] = "Initialized";
    Status[Status["Processing"] = 1] = "Processing";
    Status[Status["Success"] = 2] = "Success";
    Status[Status["Failed"] = 3] = "Failed";
    Status[Status["Skipped"] = 4] = "Skipped";
})(Status || (Status = {}));
const JobStatus = ({ status, intl }) => {
    let statuses = [];
    if (status === Status.Initialized || status === Status.Processing) {
        statuses = ['info', 'active'];
    }
    if (status === Status.Success) {
        statuses = ['success'];
    }
    if (status === Status.Failed) {
        statuses = ['danger'];
    }
    if (status === Status.Skipped) {
        statuses = ['warning'];
    }
    return (_jsx(StatusLabel, Object.assign({ statuses: statuses, className: "document-status-label" }, { children: formatListValue({ id: status, list: 'jobstatus', intl }) })));
};
export default JobStatus;
